import React from 'react';

const DividerDot = () => <span className="text-gray-500 mx-1">&middot;</span>

export default DividerDot;
